import * as React from "react";
import { Link } from "react-router-dom";
import Loader from "../../../components/atoms/Loader";
import TabsNavi from "../../../components/molecules/TabsNavi";
import SectionInterface from "../../../interfaces/SectionInterface";
import { AiAssistantTemplateInterface } from "../useFetchAiAssistantTemplates";
import AiAssistantTemplateList from "./AiAssistantTemplateList";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  aiAssistantTemplates: AiAssistantTemplateInterface[];
  isLoading: boolean;
}

const SectionsSettingsAiAssistantTemplates = (props: Props) => {
  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "テンプレート",
            link: `/sections/${props.section.id}/settings/karte_templates`,
            active: false,
          },
          {
            label: "AIアシスタント",
            link: `/sections/${props.section.id}/settings/ai_assistant_templates`,
            active: true,
          },
        ]}
      />
      <div className={styles.newLink}>
        <Link
          to={`/sections/${props.section.id}/settings/ai_assistant_templates/new`}
          className={`buiButtonBase buiButtonVariantFilled ${styles.Btn}`}
        >
          新規作成
        </Link>
      </div>
      <div className={styles.tableWrapper}>
        <AiAssistantTemplateList
          sectionId={props.section.id}
          aiAssistantTemplates={props.aiAssistantTemplates}
        />
      </div>
      <Loader loading={props.isLoading} />
    </React.Fragment>
  );
};

export default SectionsSettingsAiAssistantTemplates;
